import {bp} from '../core/namespace.js';
import {landingPageRedirectRules, zoomLevelToShowBrokerMarkers} from './landing_page_redirect.js';

/**************
 * bp.maps
 */

// global vars
var map;
var markers = [];
var tempmarker = null;
var mouseOverTarget = null;
var mapLoaded = false;
var currentBusinessPark = {};
var terraDraw;
var terraDrawIsReady = false;
var terraDrawPendingMode = 'select';
var terraDrawStartupAttempts = 0;
var terraDrawControlsMounted = false;
var mapCircle = 0;
var totalCircles = 0;
var mapPolygon = 0;
var totalPolygons = 0;
var movementCheckbox = 0;
var executed = false;
var filteredMarkers = []
var loadInProgress = false;
var polyShapeButtonText;
var CircleShapeButtonText;

var customGeoZoom = false; // indicates if zoom was changed by backend

$.extend(true, bp, {

  maps: (function () {

    /* private variables */
    var largestBounds;
    var icons = []
    var noticeDiv;
    var opts = {
      latitude: 52.006370,
      longitude: 5.034112,
      zoom: 11,
      data_url: undefined,
      load_markers_callback: undefined,
      map_style: 'search', // search, geopage, esofdetail
      link: undefined,
      list_loaded: false,
    }
    var regex = /&p=\d+/;

    // List for bootstrap environment changes and close infoWindow when
    // environment changes to bootstrap's xs
    $(window).on('bp-bootstrap-environment-change', function () {
      if (bp.bootstrap.get_bootstrap_environment() === 'xs' && typeof bp.maps.currentInfoWindow !== 'undefined') {
        bp.maps.currentInfoWindow.close();
      }
    });


    function _fitsWithin(innerBounds, outerBounds) {
      return outerBounds.contains(innerBounds.getSouthWest()) && outerBounds.contains(innerBounds.getNorthEast())
    }

    return {
      /* public variables */
      timeoutID: undefined,
      mapIdleListener: undefined,
      // markerCluster: undefined,
      currentInfoWindow: undefined,
      currentBrokerInfoWindow: undefined,
      mouseOverTarget: undefined,
      tempmarker: undefined,
      activeMarker: undefined,
      hoveredMarker: undefined,
      tilesLoaded: false,
      userInteracting: false,
      programmaticMove: false,
      _wheelTimer: undefined,

      selectedShape: undefined, // When clicking on a shape it becomes selectedShape. This the user can have control over multiple shapes.
      shapeTypeById: {},
      isLoaded: function () {
        return mapLoaded;
      },
      showCurrentBusinessPark: function () {
        if (Object.keys(currentBusinessPark).length > 0 && map) {
          currentBusinessPark.setMap(map);
        }
      },


      /**
       * Loads custom options and initializes map
       */
      init: function (custom_opts) {
        custom_opts = typeof custom_opts !== 'undefined' ? custom_opts : {};

        // override zoom if set from backend template
        try {
          let dataset = document.getElementById('attributes_div').dataset
          if(dataset && dataset.zoomoverride){
            let z = parseInt(dataset.zoomoverride)
            custom_opts.zoom = z
          }

          $.extend(true, opts, custom_opts)
        } catch (e) {

          $.extend(true, opts, custom_opts);
        }

        // initialise landing page redirect rules
        landingPageRedirectRules()
        bp.maps.addIcons(icons)

        // check movement checkbox
        try {
            if(document.getElementById('overlayid').checked) {
              movementCheckbox = 1;
            }
        } catch (e){
          console.debug(e, "No overlayid")
        }

        // prototype marker to story pk
        google.maps.Marker.prototype.object_pk;

        if (isNaN(opts.latitude) || isNaN(opts.longitude) || isNaN(opts.zoom)) {
          //throw new Error('LatLongZoom result is invalid');
          opts.latitude = 52.006370;
          opts.longitude = 5.034112;
          opts.zoom = 11;
          opts.minZoom = 11;
        }
        var map_options = {
          center: new google.maps.LatLng(opts.latitude, opts.longitude),
          zoom: opts.zoom,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles:
            [
              {
                  "featureType": "all",
                  "elementType": "labels.text",
                  "stylers": [
                      {
                          "visibility": "on"
                      }
                  ]
              },
              {
                  "featureType": "all",
                  "elementType": "labels.icon",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "poi",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "labels.icon",
                  "stylers": [
                      {
                          "visibility": "simplified"
                      }
                  ]
              },
              {
                  "featureType": "transit",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "on"
                      }
                  ]
              }
          ],
          mapTypeControl: false,
          streetViewControl: false,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
          },
        }
        if ($(window).width() < 768) {
          $.extend(map_options, {
            mapTypeControl: false,
            streetViewControl: false,
            scrollwheel: false,
            gestureHandling: "greedy"
          });
        }
        if (opts.map_style === 'geopage') {
          $.extend(map_options, {
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            scrollwheel: true,
          });
        }
        if (opts.map_style === 'esofdetail') {
          $.extend(map_options, {
            draggable: false,
            scrollwheel: false,
            mapTypeControl: false,
            gestureHandling: true,
          });
        }
        if (opts.map_style === 'estate_profile') {
          $.extend(map_options, {
            zoom: 8,
          });
        }

        map = new google.maps.Map(document.getElementById('map-canvas'), map_options);

        // map listeners, add them after map is loaded
        if (opts.map_style === 'esofdetail') {
          // add one single marker to map center
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(opts.latitude, opts.longitude),
            icon: icons['estate_offer'],
            shadow: icons['estate_offer_shadow']
          });
          marker.setMap(map);
          console.debug("set map loaded")
          mapLoaded = true; // set map to loaded true required as parseMarkerResults not called.

          // load the markers for the estate profile
        } else if (opts.map_style === 'estate_profile') {
          var numOfMarkers = 0;
          $.getJSON(opts.data_url + '?', function (result) {
            numOfMarkers = result.data.length;
            // check if we need to zoom
            bp.maps.checkGeoZoom()
            bp.maps.parseMarkerResults({"results": result.data}, )

          });


        } else {
          // default event for triggering map load for
          // none estate_profile or esof_detail maps

          // loads markers when map is idle
          this.mapIdleListener = google.maps.event.addListener(map, 'idle', function () {
            google.maps.event.removeListener(bp.maps.mapIdleListener);
            if (opts.load_markers_callback !== undefined) {
              opts.load_markers_callback();
            } else {
               // load markers if checkbox set or not is poly/circle
              if (!mapLoaded){
                bp.maps.load_markers();
              } else if(movementCheckbox === 1 || (mapCircle === 0 && mapPolygon === 0)) {
                bp.maps.load_markers();
              }
            }

            google.maps.event.addListener(map, 'bounds_changed', function () {
              clearTimeout(bp.maps.timeoutID);
              bp.maps.timeoutID = setTimeout(function () {
                if (movementCheckbox === 0) {
                  document.getElementById("floating-panel").childNodes[2].nodeValue = "Dit gebied doorzoeken"
                }
                if ((movementCheckbox === 1 || mapCircle === 0 && mapPolygon === 0)) {
                  bp.maps.bounds_changed();
                }
              }, 500);
            });
            
            // Detect user-initiated interactions
            google.maps.event.addListener(map, 'dragstart', function(){ bp.maps.userInteracting = true; });
            google.maps.event.addListener(map, 'dragend', function(){ bp.maps.userInteracting = true; });
            google.maps.event.addListener(map, 'idle', function(){
              if (bp.maps.userInteracting && !bp.maps.programmaticMove) {
                // Only let a user pan/zoom affect the search state when
                // "Zoek als ik de kaart verschuif" is enabled; with the
                // toggle off, moving the map must not change the search.
                if (movementCheckbox === 1) {
                  try { bp.search.clear_geo_selection(); } catch(e) { console.debug('clear_geo_selection failed', e) }
                }
                bp.maps.userInteracting = false;
              }
              // reset programmatic guard after idle completes
              bp.maps.programmaticMove = false;
            });
            try {
              var mapDiv = map.getDiv();
              mapDiv.addEventListener('wheel', function(){
                bp.maps.userInteracting = true;
                clearTimeout(bp.maps._wheelTimer);
                bp.maps._wheelTimer = setTimeout(function(){ bp.maps.userInteracting = false; }, 800);
              }, {passive: true});
              mapDiv.addEventListener('touchstart', function(){ bp.maps.userInteracting = true; }, {passive: true});
              mapDiv.addEventListener('mousedown', function(){ bp.maps.userInteracting = true; }, {passive: true});
            } catch(e) { console.debug('mapDiv listeners failed', e) }
            
            // Add zoom change listener for broker markers
            var previousZoom = map.getZoom();
            google.maps.event.addListener(map, 'zoom_changed', function () {
              var currentZoom = map.getZoom();
              // Only reload markers when crossing the zoom 17/18 threshold
              if (currentZoom > zoomLevelToShowBrokerMarkers && 
                  ((previousZoom < 18 && currentZoom >= 18) || (previousZoom >= 18 && currentZoom < 18))) {
                bp.maps.loadBrokerOfficeMarkers();
              }
              previousZoom = currentZoom;
            });
          });

          // link
          if (opts.link !== 'geopage' && opts.link !== undefined) {
            $('#map-canvas').css('cursor', 'pointer');
            google.maps.event.addListener(map, 'click', function () {
              document.location = opts.link;
            });
          }

          if (bp.maps.tilesLoaded) {
            bp.maps.set_marker_as_active()
          }

          google.maps.event.addListener(map, 'tilesloaded', function () {
            bp.maps.tilesLoaded = true;
          });

          $('.custom-map-control-button').click(function () {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                  };

                  $.getJSON(`/in_nl_check/${pos.lng}/${pos.lat}/`,
                    function (result) {
                      if (result["response"] === true) {
                        // only set location if in nl
                        bp.maps.position = new google.maps.LatLng(pos.lat, pos.lng);
                        bp.maps.content = "Locatie gevonden.";
                        map.setCenter(pos);
                        map.setZoom(12);
                      } else {
                        console.debug('User not in nl')
                      }
                    }).fail(function () {
                    console.debug('check failed')
                  })

                }, error => {
                  alert('Pas je locatie instellingen aan om je huidige locatie te gebruiken.');
                }
              );
            }
          });

        }

        bp.maps.initDrawingControls();
      },

      initDrawingControls: function () {
        if (!map) {
          return;
        }

        if (!terraDrawControlsMounted) {
          google.maps.event.addListener(map, 'click', function () {
            bp.maps.clearSelection();
          });
          var customControlDiv = document.createElement("div");
          bp.maps.customControl(customControlDiv, map);
          map.controls[google.maps.ControlPosition.RIGHT_TOP].push(customControlDiv);
          terraDrawControlsMounted = true;
        }

        if (terraDraw) {
          return;
        }

        // Google Maps adapter needs the map projection/event element to exist first.
        if (!map.getProjection()) {
          google.maps.event.addListenerOnce(map, 'projection_changed', function () {
            window.setTimeout(function () {
              bp.maps.initDrawingControls();
            }, 0);
          });
          return;
        }

        bp.maps.initTerraDraw();
      },

            // Sets the map on all markers in the array.
      setMapOnAll: function (map) {
        for (let marker of markers) {
          marker.setMap(map);
        }
      },

      // Removes the markers from the map, but keeps them in the array.
      hideMarkers: function () {
        this.setMapOnAll(null);
      },

      // Deletes all markers in the array by removing references to them.
      deleteMarkers: function () {
        if (movementCheckbox === 1) {
          this.hideMarkers();
          markers = [];
          // Also remove broker office markers
          bp.maps.removeBrokerOfficeMarkers();
        } else if (mapCircle === 0 && mapPolygon === 0) {
          this.hideMarkers();
          markers = [];
          // Also remove broker office markers
          bp.maps.removeBrokerOfficeMarkers();
        }
      },

      // Removes the markers from the map, but keeps them in the array.
      hideMarkers_circle: function (i) {
        if (i !== 'undefined' || i !== -1) {
          markers[i].setMap(null);
        }
      },

      // Shows any markers currently in the array.
      showMarkers: function () {
        this.setMapOnAll(map);
      },

      // Deletes all markers in the array by removing references to them.
      deleteMarkerById: function (i) {
        if (i !== 'undefined' || i !== -1) {
          this.hideMarkers_circle(i);
          markers.splice(i, 1)
        }
      },

      addIcons: function (icons) {
        var favoriteMarkerSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="shadow" x="-30%" y="-20%" width="160%" height="160%"><feDropShadow dx="0" dy="1" stdDeviation="1.2" flood-color="#000000" flood-opacity=".35"/></filter></defs><path filter="url(#shadow)" d="M12 1.5C7.6 1.5 4 5.05 4 9.45c0 5.75 8 13.05 8 13.05s8-7.3 8-13.05C20 5.05 16.4 1.5 12 1.5z" fill="#EAB308" stroke="#CA8A04" stroke-width="2"/><path d="M12 13.7l-.82-.74C8.38 10.42 6.55 8.77 6.55 6.74c0-1.66 1.3-2.99 2.96-2.99.94 0 1.83.43 2.49 1.11.66-.68 1.55-1.11 2.49-1.11 1.66 0 2.96 1.33 2.96 2.99 0 2.03-1.83 3.68-4.63 6.22L12 13.7z" fill="#FFFFFF" transform="translate(0 3) scale(.78) translate(3.4 1.6)"/></svg>';
        icons['estate_offer'] = new google.maps.MarkerImage(static_url + 'img/maps/default-icon.png', new google.maps.Size(24.0, 24.0), new google.maps.Point(0, 0), new google.maps.Point(16.0, 24.0));
        icons['estate_offer_favorite'] = bp.maps.favorite_map_markers_enabled()
          ? new google.maps.MarkerImage('data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(favoriteMarkerSvg), new google.maps.Size(24.0, 24.0), new google.maps.Point(0, 0), new google.maps.Point(16.0, 24.0))
          : icons['estate_offer'];
        icons['estate_offer_grey'] = new google.maps.MarkerImage(static_url + 'img/maps/icon-grey.png', new google.maps.Size(24.0, 24.0), new google.maps.Point(0, 0), new google.maps.Point(16.0, 24.0));
        icons['estate_offer_shadow'] = new google.maps.MarkerImage(static_url + 'img/maps/default-icon-shadow.png', new google.maps.Size(36.0, 30.0), new google.maps.Point(0, 0), new google.maps.Point(10.0, 30.0));
        icons['blue'] = new google.maps.MarkerImage(static_url + 'img/maps/bounce.png', new google.maps.Size(40.0, 40.0), new google.maps.Point(0, 0), new google.maps.Point(24.0, 40.0));
        icons['leaf'] = new google.maps.MarkerImage(static_url + 'css/leaflet/images/marker-icon.png', new google.maps.Size(20.0, 30.0), new google.maps.Point(0, 0), new google.maps.Point(10.0, 30.0));
        
        // Enhanced broker office markers
        icons['broker_office_base'] = new google.maps.MarkerImage(static_url + 'img/maps/broker-office-base.png', new google.maps.Size(40.0, 50.0), new google.maps.Point(0, 0), new google.maps.Point(20.0, 50.0));
        icons['broker_office'] = new google.maps.MarkerImage(static_url + 'img/maps/icon-grey.png', new google.maps.Size(24.0, 24.0), new google.maps.Point(0, 0), new google.maps.Point(12.0, 24.0));
        icons['broker_office_shadow'] = new google.maps.MarkerImage(static_url + 'img/maps/default-icon-shadow.png', new google.maps.Size(36.0, 30.0), new google.maps.Point(0, 0), new google.maps.Point(10.0, 30.0));
      },

      favorite_map_markers_enabled: function () {
        return window.bp_feature_flags !== undefined
          && window.bp_feature_flags.ENABLE_FAVORITE_MAP_MARKERS === true;
      },

      initTerraDraw: function () {
        var terraDrawNamespace = window.terraDraw || window.TerraDraw;
        var terraDrawGoogleNamespace = window.terraDrawGoogleMapsAdapter || window.TerraDrawGoogleMapsAdapter;
        if (!terraDrawNamespace || !terraDrawGoogleNamespace) {
          console.warn('Terra Draw is unavailable; shape drawing controls disabled.');
          return;
        }

        var TerraDraw = terraDrawNamespace.TerraDraw || terraDrawNamespace;
        var TerraDrawFreehandMode = terraDrawNamespace.TerraDrawFreehandMode;
        var TerraDrawCircleMode = terraDrawNamespace.TerraDrawCircleMode;
        var TerraDrawSelectMode = terraDrawNamespace.TerraDrawSelectMode;
        var TerraDrawGoogleMapsAdapter = terraDrawGoogleNamespace.TerraDrawGoogleMapsAdapter || terraDrawGoogleNamespace;

        if (!TerraDraw || !TerraDrawFreehandMode || !TerraDrawCircleMode || !TerraDrawSelectMode || !TerraDrawGoogleMapsAdapter) {
          console.warn('Terra Draw classes are unavailable; shape drawing controls disabled.');
          return;
        }

        var mapElement = map && map.getDiv ? map.getDiv() : null;
        if (!mapElement) {
          console.warn('Terra Draw cannot start without a map element.');
          return;
        }
        if (!mapElement.id) {
          mapElement.id = 'map-canvas';
        }

        terraDrawIsReady = false;
        terraDraw = new TerraDraw({
          adapter: new TerraDrawGoogleMapsAdapter({
            lib: google.maps,
            map: map,
            coordinatePrecision: 9,
          }),
          modes: [
            new TerraDrawFreehandMode({
              drawInteraction: 'click-drag',
            }),
            new TerraDrawCircleMode({
              drawInteraction: 'click-drag',
            }),
            new TerraDrawSelectMode({
              flags: {
                polygon: {
                  feature: {
                    draggable: true,
                    rotateable: true,
                    coordinates: {
                      midpoints: true,
                      draggable: true,
                      deletable: true,
                    },
                  },
                },
              },
            }),
          ],
        });

        var startResult;
        try {
          startResult = terraDraw.start();
        } catch (error) {
          bp.maps.handleTerraDrawStartError(error);
          return;
        }
        if (startResult && typeof startResult.catch === 'function') {
          startResult.catch(function (error) {
            bp.maps.handleTerraDrawStartError(error);
          });
        }

        terraDraw.on('ready', function () {
          terraDrawIsReady = true;
          terraDrawStartupAttempts = 0;
          terraDraw.setMode(terraDrawPendingMode || 'select');
          terraDrawPendingMode = undefined;
        });

        terraDraw.on('finish', function (id, context) {
          if (!id || !context || !context.mode) {
            return;
          }
          if (context.mode === 'freehand' || context.mode === 'circle') {
            bp.maps.handleTerraDrawShapeComplete(id, context.mode);
          }
        });

        terraDraw.on('select', function (id) {
          if (!id) {
            return;
          }
          bp.maps.setSelection({
            id: id,
            type: bp.maps.getShapeTypeById(id),
          });
        });

        terraDraw.on('deselect', function () {
          bp.maps.clearSelection();
        });

        terraDraw.on('change', function (ids, type) {
          if (type !== 'delete' || !Array.isArray(ids)) {
            return;
          }
          ids.forEach(function (id) {
            bp.maps.clearShapeTypeById(id);
          });
          if (terraDraw.getSnapshot().length === 0) {
            bp.maps.handleAllShapesRemoved();
          }
        });
      },

      handleTerraDrawStartError: function (error) {
        terraDraw = undefined;
        terraDrawIsReady = false;
        terraDrawStartupAttempts += 1;
        console.warn('Terra Draw start failed, retrying when map is ready.', error);
        if (terraDrawStartupAttempts > 5) {
          console.error('Terra Draw failed to initialize after retries.');
          return;
        }
        window.setTimeout(function () {
          bp.maps.initDrawingControls();
        }, 120 * terraDrawStartupAttempts);
      },

      setTerraDrawMode: function (mode) {
        if (!terraDraw) {
          return;
        }
        if (!terraDrawIsReady) {
          terraDrawPendingMode = mode;
          return;
        }
        var currentMode = typeof terraDraw.getMode === 'function' ? terraDraw.getMode() : 'select';
        var isSwitchingDrawingModes = currentMode !== mode && currentMode !== 'select' && mode !== 'select';
        if (isSwitchingDrawingModes) {
          terraDraw.setMode('select');
          bp.maps.clearSelection();
        }
        terraDraw.setMode(mode);
      },

      getShapeTypeById: function (id) {
        if (!bp.maps.shapeTypeById) {
          bp.maps.shapeTypeById = {};
        }
        return bp.maps.shapeTypeById[id] || 'polygon';
      },

      setShapeTypeById: function (id, type) {
        if (!bp.maps.shapeTypeById) {
          bp.maps.shapeTypeById = {};
        }
        bp.maps.shapeTypeById[id] = type;
      },

      clearShapeTypeById: function (id) {
        if (!bp.maps.shapeTypeById) {
          bp.maps.shapeTypeById = {};
        }
        delete bp.maps.shapeTypeById[id];
      },

      getTerraDrawFeatureById: function (id) {
        if (!terraDraw) {
          return undefined;
        }
        var snapshot = terraDraw.getSnapshot();
        return snapshot.find(function (feature) {
          return feature.id === id;
        });
      },

      getFeaturePrimaryRing: function (feature) {
        if (!feature || !feature.geometry || !feature.geometry.coordinates) {
          return [];
        }
        if (feature.geometry.type === 'Polygon') {
          return feature.geometry.coordinates[0] || [];
        }
        if (feature.geometry.type === 'MultiPolygon') {
          return feature.geometry.coordinates[0] && feature.geometry.coordinates[0][0]
            ? feature.geometry.coordinates[0][0]
            : [];
        }
        return [];
      },

      getFeatureBounds: function (feature) {
        var ring = bp.maps.getFeaturePrimaryRing(feature);
        if (ring.length === 0) {
          return undefined;
        }
        var bounds = new google.maps.LatLngBounds();
        ring.forEach(function (coordinate) {
          if (!Array.isArray(coordinate) || coordinate.length < 2) {
            return;
          }
          bounds.extend(new google.maps.LatLng(coordinate[1], coordinate[0]));
        });
        return bounds;
      },

      pointInPolygon: function (lat, lng, ring) {
        var inside = false;
        for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
          var xi = ring[i][0];
          var yi = ring[i][1];
          var xj = ring[j][0];
          var yj = ring[j][1];
          var intersects = ((yi > lat) !== (yj > lat))
            && (lng < ((xj - xi) * (lat - yi) / (yj - yi)) + xi);
          if (intersects) {
            inside = !inside;
          }
        }
        return inside;
      },

      getFeatureMarkerFilter: function (feature) {
        var ring = bp.maps.getFeaturePrimaryRing(feature);
        return function (marker) {
          var markerPosition = marker.getPosition();
          return bp.maps.pointInPolygon(markerPosition.lat(), markerPosition.lng(), ring);
        };
      },

      updateShapeUiState: function () {
        $('#custom-BtnCircle').css({
          'cursor': 'not-allowed',
          'opacity': '0.6'
        });
        $('#custom-BtnPolygon').css({
          'cursor': 'not-allowed',
          'opacity': '0.6'
        });
      },

      resetShapeUiState: function () {
        $('#custom-BtnCircle').css({
          'cursor': 'pointer',
          'opacity': '1'
        });
        $('#custom-BtnPolygon').css({
          'cursor': 'pointer',
          'opacity': '1'
        });
      },

      handleTerraDrawShapeComplete: function (id, mode) {
        var feature = bp.maps.getTerraDrawFeatureById(id);
        if (!feature) {
          return;
        }

        var shapeType = mode === 'circle' ? 'circle' : 'polygon';
        bp.maps.setShapeTypeById(id, shapeType);
        bp.maps.setSelection({
          id: id,
          type: shapeType,
        });

        var snapshot = terraDraw.getSnapshot();
        var featureIdsToDelete = snapshot
          .map(function (item) { return item.id; })
          .filter(function (featureId) { return featureId !== id; });
        if (featureIdsToDelete.length > 0) {
          terraDraw.removeFeatures(featureIdsToDelete);
          featureIdsToDelete.forEach(function (featureId) {
            bp.maps.clearShapeTypeById(featureId);
          });
        }

        totalPolygons = shapeType === 'polygon' ? 1 : 0;
        mapPolygon = totalPolygons;
        totalCircles = shapeType === 'circle' ? 1 : 0;
        mapCircle = totalCircles;
        window.dispatchEvent(new Event('mapShapeDrawingComplete'));
        bp.maps.deleteMarkers();
        bp.maps.updateShapeUiState();
        $('#overlayid').prop('checked', false);
        movementCheckbox = 0;

        var bounds = bp.maps.getFeatureBounds(feature);
        if (bounds) {
          map.fitBounds(bounds);
        }

        var boundsUrl = bounds ? bounds.toUrlValue() : undefined;
        var final_markers_url = bp.maps.getMarkersUrl(opts, map, boundsUrl);
        var checkCondition = bp.maps.getFeatureMarkerFilter(feature);
        $.getJSON(final_markers_url, function (result) {
          bp.maps.parseMarkerResults(result, checkCondition);
          $('#bploading-spinner').fadeOut(100);
          bp.common.hide_loading_notification();
        });

        bp.maps.setTerraDrawMode('select');
      },


      customControl: function (controlDiv, map) {
        /**
        * Custom controls
        * **/
        function detectMob() {
          const toMatch = [
            /iPhone/i,
            /iPad/i,
            /iPod/i,
          ];

          return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
          });
        }

        if (detectMob() && window.location.pathname === "/zoeken/") {
          var polyShapeButtonUI = document.createElement("div");
          polyShapeButtonUI.id = "custom-BtnPolygon";
          polyShapeButtonUI.style.backgroundColor = "#fff";
          polyShapeButtonUI.style.border = "2px solid #fff";
          polyShapeButtonUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
          polyShapeButtonUI.style.cursor = "pointer";
          polyShapeButtonUI.style.marginTop = "11px";
          polyShapeButtonUI.style.marginRight = "10px";
          polyShapeButtonUI.style.textAlign = "center";
          polyShapeButtonUI.style.width = "40px";
          polyShapeButtonUI.style.verticalAlign = "middle";
          polyShapeButtonUI.style.maxWidth = "40px";
          polyShapeButtonUI.title = "Vrij tekenen.";
        } else if (detectMob() && window.location.pathname !== "/zoeken/") {
          var polyShapeButtonUI = document.createElement("div");
          polyShapeButtonUI.id = "custom-BtnPolygon";
          polyShapeButtonUI.style.backgroundColor = "#fff";
          polyShapeButtonUI.style.border = "2px solid #fff";
          polyShapeButtonUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
          polyShapeButtonUI.style.cursor = "pointer";
          polyShapeButtonUI.style.marginTop = "106px";
          polyShapeButtonUI.style.marginRight = "10px";
          polyShapeButtonUI.style.textAlign = "center";
          polyShapeButtonUI.style.width = "40px";
          polyShapeButtonUI.style.verticalAlign = "middle";
          polyShapeButtonUI.style.maxWidth = "40px";
          polyShapeButtonUI.title = "Vrij tekenen.";
        } else {
          var polyShapeButtonUI = document.createElement("div");
          polyShapeButtonUI.id = "custom-BtnPolygon"
          polyShapeButtonUI.style.backgroundColor = "#fff";
          polyShapeButtonUI.style.border = "2px solid #fff";
          polyShapeButtonUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
          polyShapeButtonUI.style.cursor = "pointer";
          polyShapeButtonUI.style.marginTop = "10px";
          polyShapeButtonUI.style.marginRight = "10px";
          polyShapeButtonUI.style.textAlign = "center";
          polyShapeButtonUI.style.width = "40px";
          polyShapeButtonUI.style.verticalAlign = "middle";
          polyShapeButtonUI.style.maxWidth = "40px";
          polyShapeButtonUI.title = "Vrij tekenen.";
        }

        // Set CSS for the control interior.
        polyShapeButtonText = document.createElement("div");
        polyShapeButtonText.style.fontFamily = "Roboto,Arial,sans-serif";
        polyShapeButtonText.style.fontSize = "18px";
        polyShapeButtonText.style.lineHeight = "38px";
        polyShapeButtonText.style.paddingLeft = "5px";
        polyShapeButtonText.style.paddingRight = "5px";
        polyShapeButtonText.innerHTML = "<i class='fa fa-draw-polygon'></i>";
        polyShapeButtonUI.appendChild(polyShapeButtonText);

        var circleShapeButtonUI = document.createElement("div");
        circleShapeButtonUI.id = "custom-BtnCircle"
        circleShapeButtonUI.style.backgroundColor = "#fff";
        circleShapeButtonUI.style.border = "2px solid #fff";
        circleShapeButtonUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        circleShapeButtonUI.style.cursor = "pointer";
        circleShapeButtonUI.style.marginTop = "2px";
        circleShapeButtonUI.style.marginRight = "10px";
        circleShapeButtonUI.style.textAlign = "center";
        circleShapeButtonUI.style.width = "100%";
        circleShapeButtonUI.style.verticalAlign = "middle";
        circleShapeButtonUI.style.maxWidth = "40px";
        circleShapeButtonUI.title = "Teken een cirkel.";

        // Set CSS for the control interior.
        CircleShapeButtonText = document.createElement("div");
        CircleShapeButtonText.style.fontFamily = "Roboto,Arial,sans-serif";
        CircleShapeButtonText.style.fontSize = "18px";
        CircleShapeButtonText.style.lineHeight = "38px";
        CircleShapeButtonText.style.paddingLeft = "5px";
        CircleShapeButtonText.style.paddingRight = "5px";
        CircleShapeButtonText.innerHTML = "<i class='far fa-circle'></i>";
        circleShapeButtonUI.appendChild(CircleShapeButtonText);

        var deleteShapeButtonUI = document.createElement("div");
        deleteShapeButtonUI.style.backgroundColor = "#fff";
        deleteShapeButtonUI.style.border = "2px solid #fff";
        deleteShapeButtonUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        deleteShapeButtonUI.style.cursor = "pointer";
        deleteShapeButtonUI.style.marginTop = "2px";
        deleteShapeButtonUI.style.marginRight = "10px";
        deleteShapeButtonUI.style.textAlign = "center";
        deleteShapeButtonUI.style.width = "100%";
        deleteShapeButtonUI.style.verticalAlign = "middle";
        deleteShapeButtonUI.style.maxWidth = "40px";
        deleteShapeButtonUI.title = "Klik om de tekening te verwijderen.";

        // Set CSS for the control interior.
        var deleteShapeButtonText = document.createElement("div");
        deleteShapeButtonText.style.fontFamily = "Roboto,Arial,sans-serif";
        deleteShapeButtonText.style.fontSize = "18px";
        deleteShapeButtonText.style.lineHeight = "38px";
        deleteShapeButtonText.style.paddingLeft = "5px";
        deleteShapeButtonText.style.paddingRight = "5px";
        deleteShapeButtonText.innerHTML = "<i class='fa fa-trash-alt'></i>";
        deleteShapeButtonUI.appendChild(deleteShapeButtonText);


        if (opts.map_style !== 'estate_profile') {
          controlDiv.appendChild(polyShapeButtonUI);
          controlDiv.appendChild(circleShapeButtonUI);
          controlDiv.appendChild(deleteShapeButtonUI);
        }

        // Setup the click event listeners: simply set the map to Chicago.
        deleteShapeButtonUI.addEventListener("click", () => {
          bp.maps.deleteSelectedShape();
          $(polyShapeButtonText).removeClass('active');
          $(CircleShapeButtonText).removeClass('active');
          polyShapeButtonText.style.color = "#666";
          CircleShapeButtonText.style.color = "#666";
        });

        polyShapeButtonUI.addEventListener("click", () => {
          bp.maps.setTerraDrawMode('freehand');
          $(CircleShapeButtonText).removeClass('active');
          CircleShapeButtonText.style.color = "#666";
          $(polyShapeButtonText).addClass('active');

          if ($(polyShapeButtonText).hasClass('active')) {
            polyShapeButtonText.style.color = "#f18918";
          }
        });

        circleShapeButtonUI.addEventListener("click", () => {
          bp.maps.setTerraDrawMode('circle');
          $(polyShapeButtonText).removeClass('active');
          polyShapeButtonText.style.color = "#666";
          $(CircleShapeButtonText).addClass('active');

          if ($(CircleShapeButtonText).hasClass('active')) {
            CircleShapeButtonText.style.color = "#f18918";
          }
        });

        // Hovers and actives on the buttons
        $(polyShapeButtonText).mouseenter(function () {
          polyShapeButtonText.style.color = "#f18918";
        });
        $(polyShapeButtonText).mouseleave(function () {
          if ($(polyShapeButtonText).hasClass('active')) {
            //donothing
          } else {
            polyShapeButtonText.style.color = "#666";
          }
        });

        $(CircleShapeButtonText).mouseenter(function () {
          CircleShapeButtonText.style.color = "#f18918";
        });
        $(CircleShapeButtonText).mouseleave(function () {
          if ($(CircleShapeButtonText).hasClass('active')) {
            //donothing
          } else {
            CircleShapeButtonText.style.color = "#666";
          }
        });

        $(deleteShapeButtonUI).mouseenter(function () {
          deleteShapeButtonUI.style.color = "#f18918";
        });
        $(deleteShapeButtonUI).mouseleave(function () {
          deleteShapeButtonUI.style.color = "#666";
        });

      },

      // Checkbox to sync and update map. Checked = yes, unchecked = no sync
      movementCheckbox: function () {
        var checkBox = document.getElementById("overlayid");
        if (checkBox.checked === true) {
          window.dispatchEvent(new Event('movementCheckboxSet'));
          movementCheckbox = 1;
          if (mapPolygon === 1 || mapCircle === 1) {
            if (movementCheckbox === 1) {
              bp.maps.load_markers()
            }
            //
          } else {
            bp.maps.load_markers()
          }
          return movementCheckbox
        } else {
          movementCheckbox = 0;
          return movementCheckbox
        }

      },

      remove_skeleton: function () {
        $('.card').hide()
        $('.resultsLoadingClass').hide()
      },

      show_skeleton: function () {
        $('.card').show()
        $('.resultsLoadingClass').show()
      },

      replace_skeleton: function () {
        $('.loaded').show()
      },

      hide_replaced_skeleton: function () {
        $('.loaded').hide()
        $('.resultsLoadingClass').show()
      },

      // Clears the selection. When changing to another shape or clicking another shape, change its border to none.
      clearSelection: function () {
        this.selectedShape = null;
      },

      // When clicking on shape, change its border to make visible shape is selected.
      setSelection: function (shape) {
        this.clearSelection();
        this.selectedShape = shape;
      },

      handleAllShapesRemoved: function () {
        totalCircles = 0;
        totalPolygons = 0;
        mapCircle = 0;
        mapPolygon = 0;
        bp.maps.resetShapeUiState();
        bp.maps.clearSelection();

        if ($('#overlayid').length > 0) {
          $('#overlayid').prop('checked', true);
        }
        movementCheckbox = 1;
        bp.maps.deleteMarkers();
        bp.maps.load_markers();
      },

      // Clears the selected shape (poly/circle) when clicking on the trash button.
      // Count circles, and set mapcircle to 0 if totalcircles on the map are 0. Then we can load_markers.
      deleteSelectedShape: function () {
        bp.maps.setTerraDrawMode('select');
        if (!this.selectedShape || !terraDraw) {
          return;
        }
        var selectedShapeId = this.selectedShape.id;
        if (!selectedShapeId) {
          return;
        }

        terraDraw.removeFeatures([selectedShapeId]);
        bp.maps.clearShapeTypeById(selectedShapeId);
        bp.maps.handleAllShapesRemoved();
      },

      jump_to_llz: function (llz) {
        latitude = parseFloat(llz.split(',')[0]);
        longitude = parseFloat(llz.split(',')[1]);
        zoom = parseInt(llz.split(',')[2]);

        if (isNaN(latitude) || isNaN(longitude) || isNaN(zoom)) {
          throw new Error('LatLongZoom result is invalid');
        }
        // programmatic move guard
        bp.maps.programmaticMove = true;
        try {
          map.setCenter(new google.maps.LatLng(latitude, longitude));
          map.setZoom(zoom);
        } catch (e) {
          console.debug('jump_to_llz error', e)
        }
      },

      get_llz: function () {
        return map.getCenter().lat().toFixed(6) + ',' + map.getCenter().lng().toFixed(6) + ',' + map.getZoom();
      },

      /* This method is called 500ms after the bounds of the map have changed
       * Only triggered when movement box is not checked
       * It disables the geo (city) filterfield (this might have been used to jump to a city just now)
       * It saves the current map center and zoom (llz)
       * It pushes the current state to the url (triggering a statechanged event and updating search results)
       */
      bounds_changed: function () {
        if (bp.bootstrap.get_bootstrap_environment() === 'lg' || $('body').hasClass('show-map')) {
          // use debounce to only throttle results
          if(movementCheckbox === 1) {
            // Clear geo selection fields on map move
            _.debounce(bp.maps.load_markers(), 1200, true) // throttling
            // Also load broker office markers when map bounds change
            _.debounce(bp.maps.loadBrokerOfficeMarkers(), 1200, true)
          }
        }
      },

      create_marker: function (marker_data) {
        /**
         * Creates a marker
         * **/
        var isFavorite = bp.maps.favorite_map_markers_enabled() && marker_data['is_favorite'] === true;
        var defaultIconKey = isFavorite ? 'estate_offer_favorite' : 'estate_offer';

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(marker_data['latitude'], marker_data['longitude']),
          icon: icons[defaultIconKey],
          shadow: icons['estate_offer_shadow'],
          object_pk: marker_data['pk'],
          is_favorite: isFavorite,
          is_extra_favorite: marker_data['is_extra_favorite'] === true,
          defaultIconKey: defaultIconKey
        });

        return marker;
      },

      get_marker_default_icon_key: function (marker) {
        if (marker.defaultIconKey) {
          return marker.defaultIconKey;
        }
        return bp.maps.favorite_map_markers_enabled() && marker.is_favorite ? 'estate_offer_favorite' : 'estate_offer';
      },

      restore_marker_icon: function (marker) {
        if (marker !== undefined) {
          marker.setIcon(icons[bp.maps.get_marker_default_icon_key(marker)]);
          marker.setZIndex(null);
        }
      },

      refresh_favorite_marker_icons: function (favorite_pks) {
        if (!bp.maps.favorite_map_markers_enabled()) {
          return;
        }
        if (typeof markers === 'undefined') {
          return;
        }

        var favoritePkStrings = (favorite_pks || []).map(function (pk) {
          return pk.toString();
        });

        markers.forEach(function (marker) {
          if (marker.defaultIconKey === 'estate_offer_grey') {
            return;
          }
          if (marker.is_extra_favorite === true) {
            return;
          }
          marker.is_favorite = favoritePkStrings.indexOf(marker.object_pk.toString()) !== -1;
          marker.defaultIconKey = marker.is_favorite ? 'estate_offer_favorite' : 'estate_offer';
          if (bp.maps.activeMarker === undefined || bp.maps.activeMarker.object_pk !== marker.object_pk) {
            bp.maps.restore_marker_icon(marker);
          }
        });
      },

      remove_extra_favorite_markers: function () {
        if (typeof markers === 'undefined') {
          return;
        }

        markers = markers.filter(function (marker) {
          if (marker.is_extra_favorite !== true) {
            return true;
          }
          marker.setMap(null);
          if (bp.maps.activeMarker !== undefined && bp.maps.activeMarker.object_pk === marker.object_pk) {
            bp.maps.activeMarker = undefined;
          }
          return false;
        });
      },

      sync_favorite_map_markers: function (show_favorites_on_map, favorite_pks) {
        if (!bp.maps.favorite_map_markers_enabled() || $('#map-canvas').length === 0 || map === undefined) {
          return;
        }

        favorite_pks = favorite_pks || [];
        bp.maps.refresh_favorite_marker_icons(favorite_pks);

        if (show_favorites_on_map !== true) {
          bp.maps.remove_extra_favorite_markers();
          return;
        }

        bp.maps.remove_extra_favorite_markers();

        var currentMarkersByPk = {};
        markers.forEach(function (marker) {
          currentMarkersByPk[String(marker.object_pk)] = marker;
        });

        var markersUrl = bp.maps.getMarkersUrl(opts, map, undefined, {
          preserve_search_context: true,
          force_show_favorites_on_map: true
        });

        $.ajax({
          dataType: "json",
          url: markersUrl,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          cache: true,
          success: function (resp) {
            var results = resp.results || [];

            results.forEach(function (marker_data) {
              if (marker_data.is_favorite !== true) {
                return;
              }

              var markerPk = String(marker_data.pk);
              if (currentMarkersByPk[markerPk] !== undefined) {
                currentMarkersByPk[markerPk].is_favorite = true;
                currentMarkersByPk[markerPk].defaultIconKey = 'estate_offer_favorite';
                bp.maps.restore_marker_icon(currentMarkersByPk[markerPk]);
                return;
              }

              if (marker_data.is_extra_favorite !== true) {
                return;
              }

              var marker = new google.maps.Marker({
                position: new google.maps.LatLng(marker_data.latitude, marker_data.longitude),
                icon: icons['estate_offer_favorite'],
                shadow: icons['estate_offer_shadow'],
                object_pk: marker_data.pk,
                is_favorite: true,
                is_extra_favorite: true,
                defaultIconKey: 'estate_offer_favorite'
              });
              markers.push(marker);
              currentMarkersByPk[markerPk] = marker;
              bp.maps.add_marker_listerners(marker);
              marker.setMap(map);
            });
          }
        });
      },


      /**
       * Add markers for the maps to handle click and mouse over events
       */
      add_marker_listerners: function (marker) {
        // add event listeners to map markers based on map type
        if (opts.link !== undefined) {
          //if link not defined. redirect to detail page
          google.maps.event.addListener(marker, "click", function () {
            document.location = opts.link
          });
        } else {
          // add event listeners to change the marker type on hover, click
          google.maps.event.addListener(marker, "click", function () {

            //reset icons and remove marker from state
            if (bp.maps.activeMarker !== undefined) {
              localStorage.mapMarker = undefined;
              bp.maps.restore_marker_icon(bp.maps.activeMarker);
              bp.maps.activeMarker = undefined;
            }

            //add new marker to state and reset the icon
            bp.maps.activeMarker = marker;
            bp.maps.activeMarker.setIcon(icons['blue']);
            bp.maps.activeMarker.setZIndex(1000);
            bp.maps.load_info_window(marker);
          });


          google.maps.event.addListener(marker, "mouseover", function () {

            bp.maps.hoveredMarker = marker;
            if (bp.maps.activeMarker === undefined || bp.maps.activeMarker.object_pk !== marker.object_pk) {
              bp.maps.hoveredMarker.setIcon(icons['blue'])
              bp.maps.hoveredMarker.setZIndex(999);
            }

          });
          google.maps.event.addListener(marker, "mouseout", function () {
            // only reset marker icon if marker has not been clicked
            if (bp.maps.activeMarker === undefined) {
              bp.maps.restore_marker_icon(marker);
            } else {

              //there is an active marker
              //only reset if marker is not active marker
              if (bp.maps.activeMarker.object_pk !== bp.maps.hoveredMarker.object_pk) {
                bp.maps.restore_marker_icon(marker);
              }
            }
            bp.maps.hoveredMarker = undefined

          });
        }

        return marker;
      },


      create_polygon: function (poly_points) {
        var shape = []
        poly_points.forEach(point => {
          shape.push({'lat': point[1], 'lng': point[0]})
        });

        // Construct the polygon.
        var businessPark = new google.maps.Polygon({
          paths: shape,
          strokeColor: '#13a8ff',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#0d93ff',
          fillOpacity: 0.35
        });

        // on mobile check
        if (bp.bootstrap.get_bootstrap_environment() !== 'lg') {
          currentBusinessPark = businessPark
        } else {
          businessPark.setMap(map);
        }
      },

      create_business_park_marker: function (marker_data, direction) {

        var iconBase =
          'https://developers.google.com/maps/documentation/javascript/examples/full/images/';

        var icons = {
          north: {
            icon: iconBase + 'parking_lot_maps.png'
          },
          south: {
            icon: iconBase + 'library_maps.png'
          },
          east: {
            icon: iconBase + 'info-i_maps.png'
          },
          west: {
            icon: iconBase + 'beachflag.png'
          }
        };


        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(marker_data['lat'], marker_data['lng']),
          icon: icons[direction].icon,
          shadow: icons['estate_offer_shadow'],
          object_pk: marker_data['pk']
        });

        marker.addListener('click', function () {
          var infowindow = new google.maps.InfoWindow({
            content: marker_data['name'] + 'number of estates ' + marker_data['count_estate_offers'],
            maxWidth: 200
          });
          infowindow.open(map, marker);
        });

        marker.setMap(map)
      },

      dispatchResultsUpdated: function () {
        let event = new Event('searchApp:resultsUpdated')
        window.dispatchEvent(event)
      },

      load_info_window: function (marker) {
        /**
         * To avoid initially loading huge data set, load map html via info window
         * the Google Maps InfoWindow and also in #ad-snippet-xs; the latter is
         * **/
        var url = '/zoeken/kaart/ajax/infowindow/';
        $.ajax({
          url: url,
          cache: true,
          async: true,
          data: {pk: marker.object_pk},
          success: function (result) {
            bp.maps.show_ad_snippet(this.map, marker, result['map_html']);

          }
        });

      },


      show_ad_snippet: function (map, marker, html) {
        /**
         * When a marker is clicked the related ad-snippet html is loaded into
         * the Google Maps InfoWindow and also in #ad-snippet-xs; the latter is
         * the div used on bootstrap-xs viewports.
         *
         * The following steps are taken
         *
         *  1. Close any open maps.InfoWindows and hide mobile ad-snippet content
         *  2. Load new ad-snippet html
         *  3. On first marker click add 'show-ad-snippet' class to container
         *  4. Always show mobile ad-snippet (anticipating viewport changes)
         *  5. Show InfoWindow when required (no viewport change anticipation)
         */
        var search_results_container = $('#search-results-map');

        // 1. Hide current ad-snippets
        search_results_container.addClass('show-ad-snippet-swapping');
        if (typeof bp.maps.currentInfoWindow !== 'undefined') {
          bp.maps.currentInfoWindow.close();
        }

        // 2. Always load the marker html in both the infowidow and in the ad-snippet-xs DIV
        // (for mobile); just in case the viewport changes and we need it.

        $('#ad-snippet-xs').html(html);
        $('#ad-snippet').html(html);


        // 3. On first load add .show-add-snippet; bootstrap-xs viewports
        // this causes the map to shift down to make space for the ad-snippet
        if (!search_results_container.hasClass('show-ad-snippet')) {
          search_results_container.addClass('show-ad-snippet');
        }

        // 4. Always 'show' ad-snippet-xs; it is hidden trough media queries in css
        search_results_container.delay(500).queue(function () {
          $(this).removeClass('show-ad-snippet-swapping').dequeue();
        });

      },

      load_markers: function (use_cache, reload_options) {
        /**
         * Loads markers
         * Calls 'bp.maps.getMarkersUrl(opts, map)' to fetch url
         * Makes an ajax call to the backend for the markers
         * Calls  'bp.maps.parseMarkerResults(resp)' to parse results
         * */
        if(loadInProgress){
          return
        }
        loadInProgress = true;
        _.throttle(bp.maps.throttled_load_markers(use_cache, reload_options),1200)
        loadInProgress = false;
      },

      throttled_load_markers: function(use_cache, reload_options){
        /**
         * Load markers either from DOM or Network
         * DOM - geo pages for now
         * **/
          document.getElementById("floating-panel").childNodes[2].nodeValue = "Zoek als ik de kaart verschuif"
          use_cache = use_cache && typeof use_cache === 'boolean';
          var markers_url;

          if (use_cache && largestBounds !== undefined && _fitsWithin(map.getBounds(), largestBounds)) {
            // we're using cache, only hide loading message and return :)
            bp.common.hide_loading_notification();
          } else {

            bp.maps.hide_notice();
            $('#bploading-spinner').fadeIn(100);

            markers_url = bp.maps.getMarkersUrl(opts, map, undefined, reload_options)
            // delete other markers
            bp.maps.remove_extra_favorite_markers()
            bp.maps.deleteMarkers()

            // can load from page or from ajax
            const markersOnPage = document.getElementById('markersOnPage')
            var skipListUpdate = reload_options && reload_options.skip_list_update === true;

            var numOfMarkers = 0;
            var markerCounter = 0;
            // Embedded geo-page markers are the first-paint snapshot only.
            // Reusing them after mapLoaded ignores the live tt/price/area
            // filters (first Te huur/Te koop click appeared to do nothing).
            if(markersOnPage && !mapLoaded){
              let markersOnPageParsed = JSON.parse(markersOnPage.textContent)

              numOfMarkers = markersOnPageParsed.length
              bp.maps.parseMarkerResults({results: markersOnPageParsed}, undefined, skipListUpdate)

              // check if customGeoZoom applied
              bp.maps.checkGeoZoom()
              // remove markersOnPage from DOM
              markersOnPage.remove()

            } else {
              if (markersOnPage) {
                markersOnPage.remove()
              }
              $.ajax({
                dataType: "json",
                url: markers_url,
                headers: {
                  'X-Requested-With': 'XMLHttpRequest'
                },
                cache: true,
                success: function (resp) {
                  numOfMarkers = resp.results_count;
                  bp.maps.parseMarkerResults(resp, undefined, skipListUpdate).catch(function (error) {
                    console.debug(error, "Marker parsing error");
                    bp.common.hide_loading_notification();
                    $('#bploading-spinner').fadeOut(100);
                  })
                },
                error: function (error) {
                  console.debug(error, "Marker loading error");
                  bp.common.hide_loading_notification();
                  $('#bploading-spinner').fadeOut(100);
                }
              });
            }

          }
      },

      checkGeoZoom: function(){
        /**
         * Check if customGeoZoom is applied
         * If so and trigger is true fit map to bounds
         */
        const zoom = document.getElementById('customGeoZoom')
        if(zoom){
          customGeoZoom = document.getElementById('customGeoZoom').textContent === 'true'
        }
      },

      getMarkersUrl: function(opts, map, bounds=undefined, reload_options=undefined){
        /**
         * Formats the url for fetching markers
         * A query is based on search form state or url passed in opts
         * and the current map options
         *
         * If map.getZoom() > 10 use wider bounds else use bounds provided.
         * **/
        var baseMapSearchUrl = '/zoeken/kaart/ajax/?'
        reload_options = reload_options || {};
        if(map !== undefined && map.getZoom() > 10 || bounds === undefined){
          bounds = map.getBounds().toUrlValue()
        }
        // update bounds on hidden search form field
        // future:, these fields should modify global state
        $("#id_bounds").val(bounds)
        $("#search-form-modal #id_bounds").val(bounds)

        // use data url if specified — only for the initial map load.
        // After that, live form state (tt, price, area) must win; otherwise
        // the first filter change re-requests the page-load snapshot.
        if (opts.data_url !== undefined && !mapLoaded){
          let url = baseMapSearchUrl + opts.data_url + '&bounds=' + bounds
          opts.data_url = undefined
          return bp.maps.add_show_favorites_on_map_param(url, reload_options.force_show_favorites_on_map === true)
        }
        if (opts.data_url !== undefined) {
          opts.data_url = undefined
        }

        // When using bounds from actual map movement, clear city field to avoid conflicts.
        // Favorite-menu toggles are not map movement; preserve the current city/search
        // context so toggling "Favorieten altijd tonen" off reloads the normal result
        // markers instead of falling back to a bounds-only request.
        let searchParams = new URLSearchParams(bp.state.get_full_url());
        let preserveSearchContext = reload_options.preserve_search_context === true
          || document.body.classList.contains('geopages');
        if (!preserveSearchContext) {
          searchParams.delete('cn');  // Remove city field when using bounds
        }
        if (
          bp.maps.favorite_map_markers_enabled()
          && (
            reload_options.force_show_favorites_on_map === true
            || (bp.favorites !== undefined && bp.favorites.show_favorites_on_map_enabled())
          )
        ) {
          searchParams.set('show_favorites_on_map', '1');
        } else {
          searchParams.delete('show_favorites_on_map');
        }
        let url = baseMapSearchUrl + searchParams.toString() + '&bounds=' + bounds;
        return url

      },

      add_show_favorites_on_map_param: function (url, force_show_favorites_on_map) {
        if (
          bp.maps.favorite_map_markers_enabled()
          && (
            force_show_favorites_on_map === true
            || (bp.favorites !== undefined && bp.favorites.show_favorites_on_map_enabled())
          )
        ) {
          return url + (url.indexOf('?') === -1 ? '?' : '&') + 'show_favorites_on_map=1';
        }
        return url;
      },

      fitMarkersToBounds: function(){
        /** Fits markers to zoom. currently applied when customGeoZoom has been set**/
        if(customGeoZoom){
          var bounds = new google.maps.LatLngBounds();

          // Loop through all of the markers and add their position to the LatLngBounds object
          for (var i = 0; i < markers.length; i++) {
            bounds.extend(markers[i].getPosition());
          }

          // Fit the map to the LatLngBounds object
          bp.maps.programmaticMove = true;
          map.fitBounds(bounds);
            // If there's only one marker, zoom out to a reasonable level
          if (markers.length < 3) {
            
            // Wait for bounds_changed event to complete before setting zoom
            google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
              // Set a more reasonable zoom level (adjust this value as needed)
              if (markers.length < 3 || currentZoom > 20) {
                // Set a more reasonable zoom level
                bp.maps.programmaticMove = true;
                map.setZoom(14); // Adjust this value as needed
              }
            });
          }
    
          // set zoom to 10
          customGeoZoom = false
        }

      },


      parseMarkerResults: async function (
        data,
        checkCondition = undefined,
        skipListUpdate = false,
      ) {
        /**
         * 1. Parses marker data
         * 2. If a check condition is provided
         *    it applies different color to markers &
         *    updates the filtered markers hidden form field
         * 3. updates map with results
         * 4. Triggers list view reload
         *
         * @param {object} `data` - the data to parse see doc below
         * {
         *   results:[{pk:1, url:'', latitude:'', longitude:''}],
         *   result_count:int,
         * }
         *
         * @param {function} `checkCondition`
         * Filters polygon/circle marker ids for updating filteredmarkers
         * form field. If there is no `checkCondition` the list view update
         * can be triggered immediately
         *
         * **/
        let markerCounter = 0
        let final_results = [];
        let final_results_grey = []

        // when there is no checkCondition to be applied,
        // the list view can be triggered immediately
        if(checkCondition === undefined && !opts.list_loaded && !skipListUpdate){
          bp.search.hx_search_pagination()
        }

        if(data.searchKey){
          Alpine.store('searchKey', data.searchKey)
        }

        data.results = data.results || [];
        if (data.results.length === 0) {
          $("#id_filtered_markers").val("");
          bp.common.hide_loading_notification();
          $('#bploading-spinner').fadeOut(100);
          opts.list_loaded = false;
          // BPCOM-1716: the map finished its (first) load even when there
          // are no results. Without this, bp.maps.isLoaded() stayed false
          // after an empty first load and the filter auto-refresh kept
          // waiting for map readiness. forceFitBounds keeps the first
          // non-empty result set zooming to its markers: the fit check is
          // `!mapLoaded || window.forceFitBounds`, and mapLoaded is now
          // already true by then.
          mapLoaded = true;
          window.forceFitBounds = true;
          bp.maps.loadBrokerOfficeMarkers();
          return 0;
        }

        // loop through the results,
        // add icon & apply filtering
        // append to the map
        data.results.forEach(function (marker_data, index) {
          var isFavorite = bp.maps.favorite_map_markers_enabled() && marker_data.is_favorite === true;
          var defaultIconKey = isFavorite ? 'estate_offer_favorite' : 'estate_offer';
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(marker_data.latitude, marker_data.longitude),
            icon: icons[defaultIconKey],
            shadow: icons['estate_offer_shadow'],
            object_pk: marker_data['pk'],
            is_favorite: isFavorite,
            is_extra_favorite: marker_data.is_extra_favorite === true,
            defaultIconKey: defaultIconKey
          });

          // add the marker to the correct list
          if(checkCondition !== undefined && !checkCondition(marker)){
            final_results_grey.push(marker_data['pk'])
            marker.defaultIconKey = 'estate_offer_grey';
            marker.setIcon(icons['estate_offer_grey'])
          } else {
            final_results.push(marker_data['pk'])
          }

          // add markers to the marker array and to the listener.
          markers.push(marker);
          bp.maps.add_marker_listerners(marker);
          marker.setMap(map);
          markerCounter = markerCounter + 1
          var marker_index = markers.indexOf(marker, index);
          if (marker_index === 'undefined' && marker_index === -1) {
            bp.maps.deleteMarkerById(marker_index);
          }
        });

        // @allMarkersVisible
        // on first load make sure markers are visible.
        // adjust
        if(!mapLoaded || window.forceFitBounds === true){
          bp.maps.fitMarkersToBounds()
          window.forceFitBounds = false
        }


        // update hidden form field that can
        // now be sent to the backend for list ordering
        if(final_results_grey.length > 1){
          let f = final_results.map((v)=>v.toString())
          $("#id_filtered_markers").val(f.join(","))
        } else {
          $("#id_filtered_markers").val("")
        }


        if(mapLoaded){

          // if there is a checkCondition we delay triggering
          // list view until after filtering applied.
          // trigger list view only if not already loaded ??
          if(checkCondition !== undefined && !opts.list_loaded && !skipListUpdate){
            bp.search.hx_search_pagination()
          }
        } else {
          mapLoaded = true
        }

        bp.common.hide_loading_notification();

        // set the list loaded to true
        opts.list_loaded = false;

        $('#bploading-spinner').fadeOut(100);

        // Load broker office markers after estate markers are loaded
        bp.maps.loadBrokerOfficeMarkers();

        return markerCounter
      },

      // find marker from cluster and set as active
      set_marker_as_active: function () {

        //test
        //set mapmarker
        if (localStorage.is_redirect && localStorage.mapMarker !== undefined && localStorage.mapMarker !== "undefined") {

          const markerData = JSON.parse(localStorage.mapMarker);
          //find the marker. set as active
          const current_markers = bp.maps.load_markers;
          const marker = current_markers.find(item => item.object_pk === markerData.object_pk);

          if (marker !== undefined) {
            //add new marker to state and reset the icon
            bp.maps.activeMarker = marker;
            bp.maps.activeMarker.setIcon(icons['blue']);
            bp.maps.activeMarker.setZIndex(1000);
            bp.maps.load_info_window(marker)
          }

          localStorage.removeItem('mapMarker');
          localStorage.removeItem('is_redirect');
        }
      },

      show_notice: function (text, title) {
        this.hide_notice();

        title = typeof title !== 'undefined' ? title : '';

        noticeDiv = document.createElement('div');
        var html = '<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>'
        if (title !== '') {
          html += '<strong>' + title + '</strong>';
        }
        html += '<p>' + text + '</p>';
        noticeDiv.innerHTML = html;
        noticeDiv.setAttribute('class', 'alert alert-warning alert-map alert-dismissable');
        noticeDiv.setAttribute('data-dismiss', 'alert');
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(noticeDiv);
      },

      hide_notice: function () {
        $(noticeDiv).remove();
      },

      close_ad_snippet: function () {
        localStorage.mapMarker = undefined;
        event.cancelBubble = true;
        if (event.stopPropagation) {
          event.stopPropagation()
        }
        var search_results_container = $('#search-results-map');
        var map = $('#map-canvas');
        // hide show_ad_snippet and resize map
        search_results_container.removeClass('show-ad-snippet');
        //change the icon
        bp.maps.restore_marker_icon(bp.maps.activeMarker);

        //reset active marker to undefined
        bp.maps.activeMarker = undefined;
      },

      //called on mouseover event on result row
      show_estate_marker: function (event, pk, lat, lng) {
        if (map === undefined) {
          return;
        }
        if (bp.maps.tempmarker === undefined) {
          // create marker

          var myLatLng = {lat: lat, lng: lng};
          bp.maps.tempmarker = new google.maps.Marker({
            position: myLatLng,
            animation: google.maps.Animation.BOUNCE,
            icon: icons['blue'],
            zIndex: 1000,
          });

          //add the marker to the map
          bp.maps.tempmarker.setMap(map)

          // set timeout to stop bounce after a 300ms
          window.setTimeout(function () {
            if (bp.maps.tempmarker !== undefined) {
              bp.maps.tempmarker.setAnimation(null)
            }
          }, 800);
        }
      },

      remove_estate_marker: function (event, pk, lat, lng) {
        if (bp.maps.tempmarker !== undefined) {
          bp.maps.tempmarker.setMap(null);
          bp.maps.tempmarker = undefined;
        }
      },

      remove_shapes_and_movements_after_search: function(){
        if (movementCheckbox === 0 || (mapCircle === 1 || mapPolygon === 1)) {

            // set all values to 0 after search button is triggered
            totalCircles = 0;
            totalPolygons = 0;
            mapCircle = 0;
            mapPolygon = 0;
            movementCheckbox = 0;

            if ($(polyShapeButtonText).hasClass('active')) {
              $(polyShapeButtonText).removeClass('active')
              polyShapeButtonText.style.color = "#666";
            }

            if ($(CircleShapeButtonText).hasClass('active')) {
              $(CircleShapeButtonText).removeClass('active')
              CircleShapeButtonText.style.color = "#666";
            }

            // Delete shapes and movementbox after search button is triggered
            bp.maps.deleteSelectedShape();
          }
      },

      // Broker office markers functionality
      brokerOfficeMarkers: [],
      brokerMarkerMapClickListener: undefined,

      loadBrokerOfficeMarkers: function() {
        if (!map) return;

        // Only load on specific pages: /zoeken and /plaats
        var currentPath = window.location.pathname;
        var allowedPaths = ['/zoeken/', '/zoeken'];
        var isPlacePath = currentPath.startsWith('/plaats/');

        if (!allowedPaths.includes(currentPath) && !isPlacePath) {
          return;
        }

        // Only show markers when zoomed in enough
        var currentZoom = map.getZoom();
        if (currentZoom <= zoomLevelToShowBrokerMarkers ) {
          // Hide existing markers if zoom is too low
          bp.maps.removeBrokerOfficeMarkers();
          return;
        }

        var bounds = map.getBounds();
        if (!bounds) return;

        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();

        $.ajax({
          url: '/zoeken/kaart/ajax/broker-markers/',
          data: {
            north: ne.lat(),
            south: sw.lat(),
            east: ne.lng(),
            west: sw.lng()
          },
          success: function(response) {
            if (response.success && response.markers) {
              bp.maps.addBrokerOfficeMarkers(response.markers);
            } else {
              console.debug('No broker markers found or invalid response');
            }
          },
          error: function(xhr, status, error) {
            console.debug('Error loading broker office markers:', error);
          }
        });
      },

      addBrokerOfficeMarkers: function(markers) {
        // Remove existing broker markers first
        bp.maps.removeBrokerOfficeMarkers();

        var currentZoom = map.getZoom();
        try{
          currentZoom = parseInt(currentZoom)
        } catch (e) {
          console.log("error", e)
        }

        if (currentZoom <= zoomLevelToShowBrokerMarkers) {
          bp.maps.removeBrokerOfficeMarkers();
          return;
        }

        markers.forEach(function(markerData) {
          var marker = bp.maps.createBrokerOfficeMarker(markerData);
          if (marker !== null) {
            bp.maps.brokerOfficeMarkers.push(marker);
          }
        });

        if (bp.maps.brokerMarkerMapClickListener !== undefined) {
          google.maps.event.removeListener(bp.maps.brokerMarkerMapClickListener);
        }
        bp.maps.brokerMarkerMapClickListener = google.maps.event.addListener(map, 'click', function () {
          bp.maps.collapseBrokerOfficeCapsules();
        });
      },

      removeBrokerOfficeMarkers: function() {
        bp.maps.brokerOfficeMarkers.forEach(function(marker) {
          marker.setMap(null);
        });
        bp.maps.brokerOfficeMarkers = [];
        if (bp.maps.brokerMarkerMapClickListener !== undefined) {
          google.maps.event.removeListener(bp.maps.brokerMarkerMapClickListener);
          bp.maps.brokerMarkerMapClickListener = undefined;
        }
      },

      collapseBrokerOfficeCapsules: function () {
        bp.maps.brokerOfficeMarkers.forEach(function (marker) {
          if (typeof marker.setExpanded === 'function') {
            marker.setExpanded(false);
          }
        });
      },

      createBrokerOfficeMarker: function(markerData) {
        if (!map || !markerData || markerData.latitude === undefined || markerData.longitude === undefined) {
          return null;
        }

        var profileUrl = markerData.profile_url || '';
        var isTouchDevice = window.matchMedia && window.matchMedia('(hover: none)').matches;

        function BrokerOfficeOverlay(data) {
          this.markerData = data;
          this.position = new google.maps.LatLng(data.latitude, data.longitude);
          this.div = null;
          this.isExpanded = false;
          this.setMap(map);
        }

        BrokerOfficeOverlay.prototype = new google.maps.OverlayView();

        BrokerOfficeOverlay.prototype.onAdd = function () {
          var markerElement = document.createElement('div');
          markerElement.className = 'bp-broker-office-marker';
          markerElement.setAttribute('title', this.markerData.company_name || this.markerData.name || 'Kantoor');
          markerElement.setAttribute('role', 'button');
          markerElement.setAttribute('tabindex', '0');

          var logoHtml = this.markerData.logo_url
            ? '<img class="bp-broker-office-logo" src="' + this.markerData.logo_url + '" alt="' + (this.markerData.company_name || 'Makelaar') + ' logo" loading="lazy">'
            : '<span class="bp-broker-office-logo-fallback">' + (this.markerData.company_name || this.markerData.name || 'K').charAt(0).toUpperCase() + '</span>';

          markerElement.innerHTML = '' +
            '<div class="bp-broker-office-pill">' +
              '<div class="bp-broker-office-icon-wrapper">' +
                '<svg class="bp-broker-office-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                  '<path d="M4 20h16v2H4zm2-1h3V5H6zm5 0h2V9h-2zm4 0h3V3h-3z"></path>' +
                '</svg>' +
              '</div>' +
              '<div class="bp-broker-office-logo-safezone">' + logoHtml + '</div>' +
            '</div>' +
            '<div class="bp-broker-office-label">Lokale makelaar</div>';

          this.div = markerElement;
          this.getPanes().overlayMouseTarget.appendChild(markerElement);

          var self = this;
          var navigateToProfile = function () {
            if (!profileUrl) {
              return;
            }
            if (typeof ga !== 'undefined') {
              ga('send', {
                'hitType': 'event',
                'eventCategory': 'broker_office',
                'eventAction': 'marker_click',
                'eventLabel': self.markerData.company_name
              });
            }
            var profileLink = document.createElement('a');
            profileLink.href = profileUrl;
            profileLink.target = '_blank';
            profileLink.rel = 'noopener noreferrer';
            document.body.appendChild(profileLink);
            profileLink.click();
            document.body.removeChild(profileLink);
          };

          markerElement.addEventListener('mouseenter', function () {
            bp.maps.collapseBrokerOfficeCapsules();
            self.setExpanded(true);
          });

          markerElement.addEventListener('mouseleave', function () {
            self.setExpanded(false);
          });

          markerElement.addEventListener('click', function (event) {
            event.stopPropagation();
            if (isTouchDevice) {
              if (!self.isExpanded) {
                bp.maps.collapseBrokerOfficeCapsules();
                self.setExpanded(true);
                return;
              }
            }
            navigateToProfile();
          });

          markerElement.addEventListener('touchstart', function (event) {
            event.stopPropagation();
          }, { passive: true });

          markerElement.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              navigateToProfile();
            }
          });
        };

        BrokerOfficeOverlay.prototype.draw = function () {
          if (!this.div) {
            return;
          }
          var projection = this.getProjection();
          if (!projection) {
            return;
          }
          var point = projection.fromLatLngToDivPixel(this.position);
          if (!point) {
            return;
          }
          this.div.style.left = point.x + 'px';
          this.div.style.top = point.y + 'px';
        };

        BrokerOfficeOverlay.prototype.onRemove = function () {
          if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
          }
          this.div = null;
        };

        BrokerOfficeOverlay.prototype.setExpanded = function (expanded) {
          this.isExpanded = expanded;
          if (!this.div) {
            return;
          }
          if (expanded) {
            this.div.classList.add('is-expanded');
          } else {
            this.div.classList.remove('is-expanded');
          }
        };

        BrokerOfficeOverlay.prototype.getPosition = function () {
          return this.position;
        };

        return new BrokerOfficeOverlay(markerData);
      }
    }
  })()
});
